import React from 'react';
import ReactMarkdown from 'react-markdown';
import { cn } from '../lib/utils';

type ChatMarkdownContentProps = {
  content: string;
  className?: string;
};

export const CHAT_MARKDOWN_PROSE_CLASSNAME =
  'text-sm prose prose-sm max-w-none dark:prose-invert prose-p:my-2 prose-p:text-foreground dark:prose-p:text-foreground prose-li:text-foreground dark:prose-li:text-foreground prose-strong:text-foreground prose-em:text-foreground';

export const ChatMarkdownContent: React.FC<ChatMarkdownContentProps> = ({
  content,
  className,
}) => (
  <div className={cn(CHAT_MARKDOWN_PROSE_CLASSNAME, className)}>
    <ReactMarkdown>{content}</ReactMarkdown>
  </div>
);
